import { useNode } from '@craftjs/core';
import { useFormContext } from 'react-hook-form';
import { useFieldState } from 'src/features/generalForms/builder/layout/panels/helpers/expression/useFieldState';
import { FormDateInputComponent } from 'src/features/generalForms/builder/types/DateInput';
import { HookFormDateRangeField } from 'src/features/generalForms/uikit/hookFormFields/hookFormDateRangeField';
import { hookFormRules } from '../../../fillingModal/react-hook-form-helper';

export const FormDateRangeInput: FormDateInputComponent = (props) => {
  const { styles } = useNode((node) => ({
    styles: node.data.custom,
  }));
  const form = useFormContext();
  const { visible, isDisabled } = useFieldState(form);
  // TODO: split errors for two date somehow
  // const multipleError = useHookFieldErrors(props.dataKey);

  if (!visible) {
    return <></>;
  }

  return (
    <div style={{ ...styles, boxSizing: 'border-box' }}>
      <HookFormDateRangeField
        control={form.control}
        name={props.dataKey!}
        disabled={isDisabled}
        defaultValue={props.defaultValue}
        labelProps={{
          text: props.title,
          isBold: true,
          tooltip: props.tooltip,
          description: props.description,
          isOptional: props.endDateIsOptional && props.startDateIsOptional,
          prefix: props.prefix,
        }}
        rules={hookFormRules({
          startDateIsRequired: !props.startDateIsOptional,
          endDateIsRequired: !props.endDateIsOptional,
        })}
        startDateErrorText={
          !props.startDateIsOptional &&
          !form.getValues(props.dataKey!)?.[0] &&
          form.formState.errors[props.dataKey!]?.message
            ? form.formState.errors[props.dataKey!]?.message?.toString()
            : undefined
        }
        endDateErrorText={
          !props.endDateIsOptional &&
          !form.getValues(props.dataKey!)?.[1] &&
          form.formState.errors[props.dataKey!]?.message
            ? form.formState.errors[props.dataKey!]?.message?.toString()
            : undefined
        }
      />
    </div>
  );
};
